module.exports = __webpack_public_path__ + "img/rascrut-3.1c481486.webp";